module.exports = __webpack_public_path__ + "img/btn_menu_xmmg_c.84c412f5.png";